/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CompanySearchResultResource
 */
export interface CompanySearchResultResource {
    /**
     * 
     * @type {string}
     * @memberof CompanySearchResultResource
     */
    companyId: string;
    /**
     * 
     * @type {string}
     * @memberof CompanySearchResultResource
     */
    name: string;
}

/**
 * Check if a given object implements the CompanySearchResultResource interface.
 */
export function instanceOfCompanySearchResultResource(value: object): value is CompanySearchResultResource {
    if (!('companyId' in value) || value['companyId'] === undefined) return false;
    if (!('name' in value) || value['name'] === undefined) return false;
    return true;
}

export function CompanySearchResultResourceFromJSON(json: any): CompanySearchResultResource {
    return CompanySearchResultResourceFromJSONTyped(json, false);
}

export function CompanySearchResultResourceFromJSONTyped(json: any, ignoreDiscriminator: boolean): CompanySearchResultResource {
    if (json == null) {
        return json;
    }
    return {
        
        'companyId': json['companyId'],
        'name': json['name'],
    };
}

export function CompanySearchResultResourceToJSON(value?: CompanySearchResultResource | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'companyId': value['companyId'],
        'name': value['name'],
    };
}

